import { PAGE_TYPE_SEARCH_RESULTS } from 'shared/consts'
import { TENANT_IT } from 'shared/consts/tenants'
import {
  SERP_ADD_TO_CART_CLICK,
  SERP_REMOVE_CTA_AND_VARIANTS,
} from 'shared/experiments/consts'
import {
  activateExperiment,
  getExperimentOnClient,
} from 'shared/experiments/utils/experiments'
import trackEvent from 'shared/experiments/utils/trackOptimizelyEvent'
import store from 'shared/store'
import { SELECTOR_ALGOLIA_CONTAINER } from 'views/assets/scripts/appendSerpBanner'

const isEnvValid = (): boolean => {
  const { isEnabled } = getExperimentOnClient(SERP_REMOVE_CTA_AND_VARIANTS)
  const { pageType } = store.getPublicRuntimeConfig()?.pageProperties || {}

  return Boolean(isEnabled && pageType === PAGE_TYPE_SEARCH_RESULTS)
}

export default () => {
  if (!isEnvValid()) {
    return
  }
  const { tenant } = store?.getPublicRuntimeConfig()?.publicConfig || {}
  void activateExperiment(SERP_REMOVE_CTA_AND_VARIANTS)

  let container = document.querySelector<HTMLElement>(
    '[data-clientside-hook~="algoliaSearchListContainer"]'
  )
  if (tenant === TENANT_IT) {
    container = document.querySelector<HTMLElement>(SELECTOR_ALGOLIA_CONTAINER)
  }

  container?.addEventListener('click', element => {
    const target = <HTMLElement>element.target

    if (
      target.closest('[data-clientside-hook~="add2CartForm"] [type=submit]')
    ) {
      trackEvent(SERP_ADD_TO_CART_CLICK)
    }
  })
}
